import React, { useState, useEffect } from "react";
import { useFilePicker } from "use-file-picker";
import "./style.scss";
import { MaterialSymbol } from "react-material-symbols";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { popinfo } from "component/Fancybox/Fancybox";

function SurveyForm ({initialSurveyData = {}, onCancel = false, onSave = false}){
  const [step, setStep] = useState(0);
  const [surveyData, setSurveyData] = useState(initialSurveyData);
  const [surveyType, setSurveyType] = useState(initialSurveyData?.SurveyEngineType || 'External');

  return (
    <div className="component-survey-form">
      
      <div className="step-indicators">
        <div className={`step-indicator ${step >= 0 ? 'active' : ''}`}></div>
        <div className={`step-indicator ${step === 1 ? 'active' : ''}`}></div>
      </div>
      {
        step === 0 && 
        <div className="generic-form survey-form-data">
          <div className="form-group">
              <label>Survey Title</label>
              <p className="text-sm mb-sm">Your survey title, make it concise and clear</p>
              <input 
                  type="text" 
                  className="form-control text" 
                  value={surveyData.SurveyTitle || ''}
                  onChange={(e) => setSurveyData({...surveyData, SurveyTitle: e.target.value})}
              />
          </div>
          <div className="form-group">
              <label>Description</label>
              <p className="text-sm mb-sm">Provide a detailed description of what your survey is about</p>
              <textarea 
                  className="form-control textarea"
                  value={surveyData.SurveyDescription || ''}
                  onChange={(e) => setSurveyData({...surveyData, SurveyDescription: e.target.value})}
              ></textarea>
          </div>
          <div className="form-group">
              <label>Required Respondents</label>
              <p className="text-sm mb-sm">Set the number of respondents needed (enter 0 if you don't want to set a quota)</p>
              <input 
                  type="number" 
                  min="0"
                  className="form-control text" 
                  value={surveyData.Quota || 0}
                  onChange={(e) => setSurveyData({...surveyData, Quota: e.target.value})}
              />
          </div>
          <div className="form-group">
              <label>Publish Survey</label>
              <label className="switch-button">
                <input
                  type="checkbox"
                  checked={surveyData.IsPublished || false}
                  onChange={(e) => {
                    setSurveyData({...surveyData, IsPublished: e.target.checked ? 1 : 0 });
                  }}
                />
                <span className="slider round"></span>
              </label>
          </div>
          <div className="form-group ">
            <label>Survey Type</label>
            <p className="text-sm mb-md">Choose between using an external survey provider or creating the survey directly on this platform</p>
            <ul className="survey-types flex flex-wrap">
              <li className={`survey-type ${surveyType === 'External' ? 'active' : ''}`}>
                <div className="survey-type-wrapper">
                  <MaterialSymbol icon="http"/>
                  <p className="leading-text">Use external survey provider</p>
                  <button 
                    className="absolute inset"
                    onClick={() => {
                      setSurveyData({...surveyData, SurveyEngineType: 'External'});
                      setSurveyType('External');
                    }}
                  ></button>
                </div>
              </li>
              <li className={`survey-type ${surveyType === 'Internal' ? 'active' : ''}`}>
                <div className="survey-type-wrapper">
                  <MaterialSymbol icon="forms_add_on"/>
                  <p className="leading-text">Create the survey directly on this platform</p>
                  <button 
                    className="absolute inset"
                    onClick={() => {
                      setSurveyData({...surveyData, SurveyEngineType: 'Internal'});
                      setSurveyType('Internal');
                    }}
                  ></button>
                </div>
              </li>
            </ul>
          </div>
          <div className="form-group text-right">
            <button className="btn btn-orange btn-reverse btn-small" onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if(onCancel)
              {
                onCancel();
              }
            }}>Cancel</button>&nbsp;
            <button className="btn btn-orange btn-small" onClick={e => {
              e.preventDefault();
              e.stopPropagation();
              if (!surveyData.SurveyTitle || !surveyData.SurveyDescription || surveyData.Quota === undefined || surveyData.Quota === null) {
                popinfo('error','Incomplete Fields','Please fill in all required fields before proceeding');
                return;
              }
              setStep(1);
            }}>Next</button>
            
          </div>
        </div>
      }
      {
        step === 1 &&
        (
          <div className="survey-form-body">
            <div className="flex flex-wrap">
              <button className="btn btn-mini btn-icon btn-primary btn-reverse" onClick={e => {
                e.stopPropagation();
                e.preventDefault();
                setStep(0);
              }}>
                <MaterialSymbol icon="arrow_back"/>
              </button>&nbsp;
            </div>
            <hr/>
            {
              surveyType === 'Internal' ? 
              <SurveyBuilder 
                surveyBody={initialSurveyData.SurveyBody || []}
                onSave={SurveyBody => {
                  const UpdatedSurvey = {...surveyData, SurveyBody: SurveyBody, SurveyEngineType: 'Internal'};
                  setSurveyData(UpdatedSurvey);
                  onSave(UpdatedSurvey);
                }}
              /> :
              <SurveyLinker SurveyLink={initialSurveyData.SurveyLink || ''} onSave={SurveyLink => {
                const UpdatedSurvey = {...surveyData, SurveyLink: SurveyLink, SurveyBody : [], SurveyEngineType: 'External'};
                setSurveyData(UpdatedSurvey);
                onSave(UpdatedSurvey);
              }}/>
            }
          </div>
        )
      }
    </div>
  )
}

function SurveyLinker({SurveyLink, onSave}){
  const [surveyURL, setSurveyURL] = useState(SurveyLink)
  return (
    <div className="survey-linker">
      <h3 className="font-semibold mb-md">Provide External Survey Link</h3>
      <div className="form-group">
          <label>Survey URL</label>
          <p className="text-sm mb-sm">The URL where your survey will be hosted</p>
          <input 
              type="text" 
              className="form-control text" 
              value={surveyURL || ''}
              onChange={(e) => setSurveyURL(e.target.value)}
          />
      </div>
      <div className="form-group text-right">
        <button className="btn btn-orange btn-small" onClick={e => {
          e.preventDefault();
          e.stopPropagation();
          if (!surveyURL || surveyURL.trim() === '') {
            popinfo('error','Incomplete URL','Please enter a valid survey URL, Must use http or https');
            return;
          }
          onSave(surveyURL);
        }}>Save URL</button>
      </div>
    </div>
  )
}

function SurveyBuilder({ surveyBody = [], onSave }) {
  const [sections, setSections] = useState(surveyBody);
  
  const addSection = () => {
    setSections([
      ...sections,
      {
        id: Date.now(),
        title: "Untitled Section",
        description: "",
        questions: [],
      },
    ]);
  };

  const updateSection = (index, updated) => {
    const newSections = [...sections];
    newSections[index] = updated;
    setSections(newSections);
  };

  const deleteSection = (index) => {
    setSections(sections.filter((_, i) => i !== index));
  };

  const handleSave = () => {
    const processedSections = sections.map(section => ({
      ...section,
      questions: section.questions.map(question => ({
        ...question,
        id: question.id, // Ensure ID is included
        images: question.images ? question.images.map(img => ({
          id: img.id,
          questionId: question.id,
          name: img.name,
          content: img.content,
          type: img.type || 'image/jpeg'
        })) : []
      }))
    }));
    
    onSave(processedSections);
  };

  const moveSection = (from, to) => {
    if (to < 0 || to >= sections.length) return;
    const newSections = [...sections];
    const [moved] = newSections.splice(from, 1);
    newSections.splice(to, 0, moved);
    setSections(newSections);
  };

  return (
    <div className="survey-builder generic-form">
      <h3 className="font-semibold mb-md">Create the survey directly on this platform</h3>
      {
        sections.length === 0 && (
          <div className="leading-text font-light empty-section mb-md wp-content">
            <h4 className="font-semibold">
              Start by creating section for your survey
            </h4>
            <p>Surveys are built using sections that contain questions. Each section can have multiple questions of different types (multiple choice, text input, etc.).</p>
            
            <h4>Key features:</h4>
            <ul>
              <li>Organize questions into logical sections</li>
              <li>Add branching logic to questions to create conditional paths</li>
              <li>View and analyze responses after publishing</li>
            </ul>
            
            <h4>Important notes:</h4>
            <ul>
              <li>Saved responses will remain intact even if you modify the survey later</li>
              <li>Branching logic references sections by ID - be careful when rearranging sections</li>
              <li>You can add as many sections and questions as needed</li>
            </ul>
            
            <p>Start by adding your first section, then add questions to it. You can always edit or rearrange sections later.</p>
          </div>
        )
      }
      {sections.map((section, i) => {
        const isSectionReferenced = sections.some(sec =>
          sec.questions.some(q =>
            q.options?.some(opt =>
              opt.branchTo?.goToSectionId != null &&
              Number(opt.branchTo.goToSectionId) === Number(section.id)
            )
          )
        );

        const referencingSection = sections.find(sec =>
          sec.questions.some(q =>
            q.options?.some(opt =>
              opt.branchTo?.goToSectionId != null &&
              Number(opt.branchTo.goToSectionId) === Number(section.id)
            )
          )
        );

        return (
          <div key={section.id} className="section-wrapper mb-lg">
            {isSectionReferenced && (
              <small className="section-movement-warning text-warning mb-sm leading-text">
                Section referenced by branching from some question in section "{referencingSection?.title || ''}". Movement & Delete is disabled
              </small>
            )}
            <SectionEditor
              section={section}
              sectionIndex={i}
              allSections={sections}
              isSectionReferenced={isSectionReferenced}
              onChange={(updated) => updateSection(i, updated)}
              onDelete={() => deleteSection(i)}
              moveSection={moveSection}
            />
          </div>
        );
      })}
      <div className="flex flex-flat">
        <button
          onClick={(e) => { e.preventDefault(); addSection(); }}
          className="btn btn-small btn-orange add-section"
        >
          Add Section
        </button>
        <button
          onClick={(e) => { e.preventDefault(); handleSave(); }}
          className="btn btn-small btn-primary save-survey"
        >
          Save Survey
        </button>
      </div>
    </div>
  );
}

function SectionEditor({ section, onChange, onDelete, allSections, isSectionReferenced, sectionIndex, moveSection }) {
  const [collapsed, setCollapsed] = useState(false);
  const [title, setTitle] = useState(section.title);
  const [description, setDescription] = useState(section.description || "");
  const [questions, setQuestions] = useState(section.questions || []);

  const addQuestion = () => {
    const newQuestionId = Date.now();
    setQuestions([
      ...questions,
      {
        id: newQuestionId,
        type: "multiple_choice",
        text: "",
        options: [
          { label: "Option 1", branchTo: { jumpToQuestionId: null, goToSectionId: null } },
          { label: "Option 2", branchTo: { jumpToQuestionId: null, goToSectionId: null } },
        ],
        required: false,
        images: [],
      },
    ]);
  };

  const updateQuestion = (index, updated) => {
    const newQuestions = [...questions];
    newQuestions[index] = updated;
    setQuestions(newQuestions);
  };

  const deleteQuestion = (index) => {
    setQuestions(questions.filter((_, i) => i !== index));
  };

  const moveQuestion = (from, to) => {
    if (to < 0 || to >= questions.length) return;
    
    // Check if destination question is referenced by any branch
    const isReferenced = allSections.some(sec =>
      sec.questions.some(q =>
        q.options?.some(opt =>
          opt.branchTo?.jumpToQuestionId != null &&
          Number(opt.branchTo.jumpToQuestionId) === Number(questions[to].id)
        )
      )
    );
    
    if (isReferenced)
    {
      popinfo('error', 'Unable to move', 'The destination position is locked, due the question is being referenced by branching');
      return;
    }

    const newQuestions = [...questions];
    const [moved] = newQuestions.splice(from, 1);
    newQuestions.splice(to, 0, moved);
    setQuestions(newQuestions);
  };

  useEffect(() => {
    onChange({ ...section, title, description, questions });
  }, [title, description, questions]);

  return (
    <>
      
      <div className="section-editor">
        <div className="section-header">
          {
            !isSectionReferenced &&
            <button
              onClick={(e) => { e.preventDefault(); onDelete(); }}
              className="btn btn-mini btn-red btn-icon delete-section"
            >
              <MaterialSymbol icon="delete" />
            </button>
          }
          <button
            onClick={(e) => { e.preventDefault(); setCollapsed(!collapsed); }}
            className="btn btn-mini collapse-toggle"
          >
            <MaterialSymbol icon={collapsed ? "expand_more" : "expand_less"} />
            {collapsed ? "Open Section" : "Hide Section"}
          </button>
          <div className="form-group flex-grow">
            <label>Section Title</label>
            <input
              type="text"
              value={title}
              className="form-control text"
              onChange={(e) => setTitle(e.target.value)}
            />
            
          </div>
          <div className="reorder-section">
            {sectionIndex > 0 && !isSectionReferenced && (
              <button
                onClick={(e) => { e.preventDefault(); moveSection(sectionIndex, sectionIndex - 1); }}
                className="btn btn-mini btn-icon move-up"
              >
                <MaterialSymbol icon="move_up" />
              </button>
            )}
            {sectionIndex < allSections.length - 1 && !isSectionReferenced && (
              <button
                onClick={(e) => { e.preventDefault(); moveSection(sectionIndex, sectionIndex + 1); }}
                className="btn btn-mini btn-icon move-down"
              >
                <MaterialSymbol icon="move_down" />
              </button>
            )}
          </div>
        </div>

        {!collapsed && (
          <>
            <div className="form-group">
              <label>Section Description</label>
              <textarea
                value={description}
                className="form-control textarea"
                onChange={(e) => setDescription(e.target.value)}
                rows={2}
              />
            </div>
            {questions.map((q, idx) => (
              <QuestionWrapper
                key={q.id}
                question={q}
                idx={idx}
                questions={questions}
                allSections={allSections}
                moveQuestion={moveQuestion}
                updateQuestion={updateQuestion}
                deleteQuestion={deleteQuestion}
                sectionIndex={sectionIndex}
              />
            ))}
            <div className="text-right mt-md">
              <button
                onClick={(e) => { e.preventDefault(); addQuestion(); }}
                className="btn btn-mini add-question"
              >
                <MaterialSymbol icon="add_circle" /> Add Question
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
}

function QuestionWrapper({ question, idx, questions, allSections, moveQuestion, updateQuestion, deleteQuestion, sectionIndex }) {
  const isQuestionReferenced = questions.some(q =>
    q.options?.some(opt => Number(opt.branchTo.jumpToQuestionId) === Number(question.id))
  );

  return (
    <div className="question-wrapper">
      {isQuestionReferenced && (
        <small className="text-warning leading-text">
          Question referenced by branching of question "{questions.find(q =>
            q.options?.some(opt => Number(opt.branchTo.jumpToQuestionId) === Number(question.id))
          )?.text || ''}". Movement & Delete is disabled
        </small>
      )}
      <QuestionEditor
        question={question}
        questionIndex={idx}
        allQuestionsInSection={questions}
        allSections={allSections}
        currentSectionIndex={sectionIndex}
        onChange={(updated) => updateQuestion(idx, updated)}
        onDelete={() => deleteQuestion(idx)}
        isQuestionReferenced={isQuestionReferenced}
      />
      
      <div className="reorder-question flex flex-wrap">
        {idx > 0 && !isQuestionReferenced && (
          <button
            onClick={(e) => { e.preventDefault(); moveQuestion(idx, idx - 1); }}
            className="btn btn-mini btn-icon move-up"
          >
            <MaterialSymbol icon="move_up" />
          </button>
        )}
        {idx < questions.length - 1 && !isQuestionReferenced && (
          <button
            onClick={(e) => { e.preventDefault(); moveQuestion(idx, idx + 1); }}
            className="btn btn-mini btn-icon move-down"
          >
            <MaterialSymbol icon="move_down" />
          </button>
        )}
      </div>
      
    </div>
  );
}

function QuestionEditor({
  question,
  onChange,
  onDelete,
  allQuestionsInSection = [],
  allSections = [],
  questionIndex = 0,
  currentSectionIndex = 0,
  isQuestionReferenced,
}) {
  // State
  const [text, setText] = useState(question.text);
  const [type, setType] = useState(question.type);
  const [options, setOptions] = useState(
    (question.options || []).map((opt) => ({
      ...(typeof opt === "string" ? { label: opt } : opt),
      branchTo: opt.branchTo || { jumpToQuestionId: null, goToSectionId: null }
    }))
  );
  const [required, setRequired] = useState(question.required);
  const [images, setImages] = useState(question.images || []);
  const [isLongAnswer, setIsLongAnswer] = useState(type === 'long_answer');
  const [branchTo, setBranchTo] = useState(question.branchTo || { 
    target: null,
    targetType: null
  });

  const [openFileSelector, { filesContent, clear }] = useFilePicker({
    readAs: "DataURL",
    accept: ["image/png", "image/jpg", "image/jpeg"],
    multiple: true,
    limitFilesConfig: { max: 5 },
    maxFileSize: 2,
  });

  useEffect(() => {
    if (filesContent && filesContent.length > 0) {
      const newImages = filesContent.map((file) => ({
        id: `img_${Date.now()}`,
        questionId: question.id,
        name: file.name,
        content: file.content,
        type: file.type
      }));
      const combined = [...images, ...newImages];
      setImages(combined);
      clear();
    }
  }, [filesContent]);

  // Get all possible branching targets
  const getBranchingTargets = () => {
    const targets = [];
    
    // Add questions from current section after this one
    allQuestionsInSection
      .map((q, idx) => ({ ...q, idx }))
      .filter((q) => q.idx > questionIndex)
      .forEach((q) => {
        targets.push({
          id: `q_${q.id}`,
          value: q.id,
          label: `Question: ${q.text || `Q${q.idx + 1}`}`,
          type: 'question'
        });
      });

    // Add sections after current section
    allSections
      .map((s, idx) => ({ ...s, idx }))
      .filter((s) => s.idx > currentSectionIndex)
      .forEach((s) => {
        targets.push({
          id: `s_${s.id}`,
          value: s.id,
          label: `Section: ${s.title || `Section ${s.idx + 1}`}`,
          type: 'section'
        });
      });

    // Add end of survey option
    targets.push({
      id: 'end',
      value: 'END',
      label: 'End of survey',
      type: 'end'
    });

    return targets;
  };

  const branchingTargets = getBranchingTargets();

  // Get current selected value for branching
  const getCurrentBranchValue = (branch) => {
    if (!branch) return '';
    
    // For multiple choice options
    if (branch.jumpToQuestionId !== undefined) {
      if (branch.jumpToQuestionId) return `q_${branch.jumpToQuestionId}`;
      if (branch.goToSectionId) return `s_${branch.goToSectionId}`;
      return '';
    }
    
    // For text question branching
    if (branch.targetType === 'question') return `q_${branch.target}`;
    if (branch.targetType === 'section') return `s_${branch.target}`;
    if (branch.target === null && branch.targetType === 'end') return 'end';
    return '';
  };

  useEffect(() => {
    if (filesContent && filesContent.length > 0) {
      const newImages = filesContent.map((file) => ({
        id: `img_${Date.now()}`, // Add unique ID for each image
        questionId: question.id, // Associate with question ID
        name: file.name,
        content: file.content,
        type: file.type
      }));
      const combined = [...images, ...newImages];
      setImages(combined);
      clear();
    }
  }, [filesContent]);

  // Sync edits back to parent
  useEffect(() => {
    const actualType = type === 'text' ? (isLongAnswer ? 'long_answer' : 'short_answer') : type;
    onChange({ 
      ...question, 
      text, 
      type: actualType, 
      options, 
      required, 
      images,
      branchTo 
    });
  }, [text, type, options, required, images, isLongAnswer, branchTo]);

  // Append newly picked images
  useEffect(() => {
    if (filesContent && filesContent.length > 0) {
      const newImages = filesContent.map((file) => ({
        name: file.name,
        content: file.content,
      }));
      const combined = [...images, ...newImages];
      setImages(combined);
      clear();
    }
  }, [filesContent]);

  // Option handlers
  const addOption = () => {
    setOptions([
      ...options,
      { 
        label: `Option ${options.length + 1}`, 
        branchTo: { 
          jumpToQuestionId: null,
          goToSectionId: null
        } 
      },
    ]);
  };

  const deleteOption = (index) => {
    const newOptions = [...options];
    newOptions.splice(index, 1);
    setOptions(newOptions);
  };

  const updateOption = (index, value) => {
    const newOptions = [...options];
    const selectedTarget = branchingTargets.find(t => t.id === value);
    
    if (value === 'end') {
      newOptions[index].branchTo = {
        jumpToQuestionId: null,
        goToSectionId: null
      };
    } else if (selectedTarget?.type === 'question') {
      newOptions[index].branchTo = {
        jumpToQuestionId: selectedTarget.value,
        goToSectionId: null
      };
    } else if (selectedTarget?.type === 'section') {
      newOptions[index].branchTo = {
        jumpToQuestionId: null,
        goToSectionId: selectedTarget.value
      };
    } else {
      newOptions[index].branchTo = {
        jumpToQuestionId: null,
        goToSectionId: null
      };
    }
    
    setOptions(newOptions);
  };

  // Handle branching change for text questions
  const handleBranchingChange = (value) => {
    const selectedTarget = branchingTargets.find(t => t.id === value);
    
    if (value === 'end') {
      setBranchTo({
        target: null,
        targetType: 'end'
      });
    } else if (selectedTarget?.type === 'question') {
      setBranchTo({
        target: selectedTarget.value,
        targetType: 'question'
      });
    } else if (selectedTarget?.type === 'section') {
      setBranchTo({
        target: selectedTarget.value,
        targetType: 'section'
      });
    } else {
      setBranchTo({
        target: null,
        targetType: null
      });
    }
  };

  // Handle type change
  const handleTypeChange = (newType) => {
    setType(newType);
    if (newType !== 'multiple_choice') {
      setOptions([]);
    } else if (options.length === 0) {
      setOptions([
        { 
          label: "Option 1", 
          branchTo: { 
            jumpToQuestionId: null,
            goToSectionId: null
          } 
        },
        { 
          label: "Option 2", 
          branchTo: { 
            jumpToQuestionId: null,
            goToSectionId: null
          } 
        },
      ]);
    }
  };

  // Remove single image
  const removeImage = (idx) => {
    const updated = [...images];
    updated.splice(idx, 1);
    setImages(updated);
  };

  // Validation flags
  const isTextInvalid = !text.trim();
  const noOptions = type === "multiple_choice" && options.length === 0;
  const hasEmptyLabel = type === "multiple_choice" && options.some((opt) => !opt.label.trim());

  return (
    <div className="question-editor">
      {/* Live Validation */}
      <div className="validation-info mb-sm">
        {isTextInvalid && (
          <small className="text-warning">Question text cannot be empty.</small>
        )}
        {noOptions && (
          <small className="text-warning">Please add at least one option.</small>
        )}
        {hasEmptyLabel && (
          <small className="text-warning">All options must have non-empty labels.</small>
        )}
      </div>

      {/* Question Text */}
      <div className="form-group">
        <label>Question Text</label>
        <input
          type="text"
          value={text}
          className="form-control text"
          onChange={(e) => setText(e.target.value)}
          placeholder="Enter your question"
        />
      </div>

      {/* Image Preview & Upload */}
      <div className="form-group">
        {images.length > 0 && (
          <Splide
            className="question-images mb-md"
            options={{ perPage: 2, pagination: false, gap: "12px", arrowPath : ' ' }}
          >
            {images.map((img, idx) => (
              <SplideSlide key={idx} className="image-box contain">
                <img src={img.content} alt={img.name} />
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    removeImage(idx);
                  }}
                  className="btn btn-mini btn-orange remove-image"
                >
                  <MaterialSymbol icon="delete" /> Remove
                </button>
              </SplideSlide>
            ))}
          </Splide>
        )}
        <div className="flex flex-wrap">
          <button
            onClick={(e) => {
              e.preventDefault();
              openFileSelector();
            }}
            className="btn btn-mini btn-primary btn-reverse upload-image"
          >
            <MaterialSymbol icon="add_photo_alternate" /> Attach Image
          </button>
          {images.length > 0 && (
            <button
              onClick={(e) => {
                e.preventDefault();
                setImages([]);
              }}
              className="btn btn-mini clear-images"
            >
              <MaterialSymbol icon="clear_all" /> Clear All
            </button>
          )}
        </div>
      </div>

      {/* Question Type */}
      <div className="form-group">
        <label>Question Type</label>
        <div className="fancy-select">
          <select
            value={type === 'short_answer' || type === 'long_answer' ? 'text' : type}
            onChange={(e) => handleTypeChange(e.target.value)}
          >
            <option value="multiple_choice">Multiple Choice</option>
            <option value="text">Text Answer</option>
          </select>
        </div>
      </div>

      {/* Text Answer Type Toggle */}
      {(type === 'text' || type === 'short_answer' || type === 'long_answer') && (
        <div className="is-long-answer flex flex-wrap text-sm" style={{justifyContent: 'flex-end'}}>
          <label className="switch-button">
            <input
              type="checkbox"
              checked={isLongAnswer}
              onChange={(e) => setIsLongAnswer(e.target.checked)}
            />
            <span className="slider round"></span>
          </label>&nbsp;Long Answer
        </div>
      )}

      {/* Branching for Text Questions */}
      {(type === 'text' || type === 'short_answer' || type === 'long_answer') && (
        <div className="form-group">
          <label>After answering, go to:</label>
          <div className="fancy-select">
            <select
              value={getCurrentBranchValue(branchTo)}
              onChange={(e) => handleBranchingChange(e.target.value)}
              disabled={branchingTargets.length === 0}
            >
              <option value="">Next question (default)</option>
              {branchingTargets
                .filter(t => t.type === 'question')
                .map((target) => (
                  <option key={target.id} value={target.id}>
                    {target.label}
                  </option>
              ))}
              {branchingTargets
                .filter(t => t.type === 'section')
                .map((target) => (
                  <option key={target.id} value={target.id}>
                    {target.label}
                  </option>
              ))}
              <option value="end">End of survey</option>
            </select>
          </div>
        </div>
      )}

      {/* Multiple Choice Options + Branching */}
      {type === "multiple_choice" && (
        <>
          {options.map((opt, i) => (
            <div key={i} className="mb-sm option-editor flex flex-flat">
              <div className="flex-wrap flex v-center items-center" style={{gap: '12px'}}>
                <div>
                  <button
                    onClick={(e) => {
                      e.preventDefault();
                      deleteOption(i);
                    }}
                    className="btn btn-mini btn-icon btn-red"
                  >
                    <MaterialSymbol icon="delete" />
                  </button>
                </div>
                <div>
                  <input
                    type="text"
                    className="form-control text"
                    value={opt.label}
                    onChange={(e) => {
                      const newOptions = [...options];
                      newOptions[i].label = e.target.value;
                      setOptions(newOptions);
                    }}
                    style={{marginBottom: 0}}
                    placeholder={`Option ${i + 1}`}
                  />
                </div>
                <div>
                  <div className="fancy-select" style={{marginBottom : 0}}>
                    <select
                      value={getCurrentBranchValue(opt.branchTo)}
                      onChange={(e) => updateOption(i, e.target.value)}
                      disabled={branchingTargets.length === 0}
                    >
                      <option value="">Next question (default)</option>
                      {branchingTargets
                        .filter(t => t.type === 'question')
                        .map((target) => (
                          <option key={target.id} value={target.id}>
                            {target.label}
                          </option>
                      ))}
                      {branchingTargets
                        .filter(t => t.type === 'section')
                        .map((target) => (
                          <option key={target.id} value={target.id}>
                            {target.label}
                          </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
          ))}

          <button
            onClick={(e) => {
              e.preventDefault();
              addOption();
            }}
            className="btn btn-mini add-option"
          >
            <MaterialSymbol icon="forms_add_on" /> Add Option
          </button>
        </>
      )}

      {/* Required Toggle */}
      <div className="text-sm flex flex-wrap required-field-toggle">
        <label className="switch-button">
          <input
            type="checkbox"
            checked={required}
            onChange={(e) => setRequired(e.target.checked)}
          />
          <span className="slider round"></span>
        </label>
        &nbsp; Required
      </div>

      {!isQuestionReferenced && (
        <div className="text-right">
          <button
            onClick={(e) => {
              e.preventDefault();
              onDelete();
            }}
            className="btn btn-mini btn-icon btn-red delete-question"
          >
            <MaterialSymbol icon="delete" />
          </button>
        </div>
      )}
    </div>
  );
}

export { SurveyForm, SurveyBuilder }